<template>
  <div style="background-color: #fff; flex: 1 1 0%;">
    <div class="flex flex-column v-center h-center">
      <share-publish-icon v-if="published"></share-publish-icon>
      <div v-else class="title-container">
        <h1>分享收集表</h1>
      </div>
      <template v-if="qrCode">
        <div>
          <img ref="image" :src="qrCode" style="border: 1px solid #c7c7c7;" />
        </div>
        <div>
          <span>收集表二维码</span>
          <a href="javascript:;" style="margin-left: 24px;">
            <el-button size="small" type="text" @click="handleSave">保存</el-button>
          </a>
          <div style="display: none;">
            <canvas ref="canvas" style="display: none;" />
            <a ref="downloader" :download="fileName" style="display: none;"></a>
          </div>
        </div>
      </template>
      <div style="padding: 12px;">
        <span>收集表链接：</span>
        <a :href="url" target="_blank">{{ url }}</a>
        <el-button
          size="small"
          type="text"
          v-clipboard:copy="url"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
          style="margin-left: 15px;"
          >复制</el-button
        >
      </div>
      <div v-if="published" style="padding: 24px;">
        <el-button size="small" type="primary" @click="goAhead"
          >继续创建</el-button
        >
        <el-button
          size="small"
          type="primary"
          style="margin-left: 48px;"
          @click="goBack"
          >返回首页</el-button
        >
      </div>
      <div v-else style="padding: 24px;">
        <el-button size="small" type="primary" @click="goBack">
          <pre style="margin: 0;">  返 回  </pre>
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Message, Button, Icon } from "element-ui";
import SharePublishIcon from "@/components/common/PublishIcon";
export default {
  name: "share-standard",
  components: {
    SharePublishIcon,
    [Button.name]: Button,
    [Icon.name]: Icon,
  },
  props: {
    qrCode: { type: String },
    url: { type: String },
    fileName: { type: String },
    published: { type: Boolean },
  },
  methods: {
    onCopySuccess() {
      Message({
        message: "链接已成功复制到剪切板，快去给小伙伴分享吧",
        type: "success",
      });
    },
    onCopyError(e) {
      console.error(e);
      Message.error("复制失败");
    },
    goAhead() {
      const event = "go-ahead";
      if (this.$listeners[event]) {
        this.$emit(event);
      } else {
        this.$router.push({
          name: "template",
        });
      }
    },
    goBack() {
      this.$router.push({
        name: "home",
      });
    },
    handleSave() {
      const { image, canvas, downloader } = this.$refs;
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;
      // 坐标(0,0) 表示从此处开始绘制，相当于偏移。
      canvas.getContext("2d").drawImage(image, 0, 0);
      downloader.href = canvas.toDataURL();
      downloader.click();
    },
  },
};
</script>
<style scoped>
.wrapper-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.title-container {
  padding: 48px;
}
.publish-container {
  color: #5d9cec;
  font-size: 48px;
  display: inline-flex;
  border: 2px solid;
  border-radius: calc(50%);
  padding: 12px;
}
.bg-img {
  mix-blend-mode: difference;
  background-color: white;
  background-image: url(../../assets/publish.png),
    linear-gradient(#5d9cec, #5d9cec);
  background-blend-mode: lighten;
  background-size: cover;
  /* filter: invert(60%); */
  min-height: 16px;
  min-width: 16px;
}
</style>
